<template>
  <v-row justify="center">
    <v-col
      cols="12"
    >
      <v-card>
        <v-card-text>
          <v-row>
            <v-col
              cols="10"
              sm="9"
            >
              <div><span>Ссылка для регистрации участника:  </span><span style="color: darkblue">{{ this.regUrl }}</span> </div>
            </v-col>
            <v-col
              cols="2"
              sm="3"
            >
              <v-btn
                color="primary"
                outlined
                @click="onClipboard"
              >
                <v-icon>mdi-clipboard-arrow-down</v-icon>
                Скопировать в буффер
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <v-img
                v-if="qrImage"
                :src="'data:image/jpg;base64,'+this.qrImage"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn
                color="info"
                outlined
                @click="onDownloadImage"
              >
                <v-icon>mdi-download</v-icon>
                Скачать
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { QrCodeService } from "@/views/loyalty/shared/services/qrcode-service"
import { downloadImageFile } from "@/views/loyalty/shared/modules/utilities"

export default {
    name: "CampaignOption",
    props: ['customerId', 'customerNumber'],
    data: () => ({
        qrImage: null,
        qrcodeService: null,
        regUrl: ''
    }),
    async beforeMount () {
        this.qrcodeService = new QrCodeService()
        console.log(window.location.hostname)
        console.log('this.customerNumber', this.customerNumber)
        this.regUrl = `${process.env.VUE_APP_URL}/loyalty/login?id=${this.customerId}&number=${this.customerNumber}`
        this.qrImage = await this.qrcodeService.getQrCode(this.regUrl)
        // console.log('this.qrImage', this.qrImage.toString())
    },
    methods: {
        onClipboard () {
            navigator.clipboard.writeText(this.regUrl)
        },
        onDownloadImage () {
            downloadImageFile('QrImage.jpg', this.qrImage)
        }

    }
}
</script>

<style scoped>

</style>
